import { z } from 'zod'

export const studentBookmarkSchema = z.object({
  schoolId: z.string().uuid('Invalid school ID'),
  notes: z.string().max(500).optional(),
})

export const recruiterBookmarkSchema = z.object({
  studentId: z.string().uuid('Invalid student ID'),
  notes: z.string().max(500).optional(),
})
